import React, { useState, useEffect, useRef } from 'react';

const SantaChatbot = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [messages, setMessages] = useState([
        { from: 'bot', text: 'OH OH OH! Benvenuto caro bambino! Sono Babbo Tech, il Babbo Natale dei programmatori! Ho ricevuto la tua chiamata dal Polo Nord!', icon: 'fa-hat-wizard' }
    ]);
    const [input, setInput] = useState('');
    const [conversationStage, setConversationStage] = useState('greeting');
    const [userName, setUserName] = useState('');
    const [wishlist, setWishlist] = useState([]);
    const [showQuickReplies, setShowQuickReplies] = useState(false);
    const [quickReplyButtons, setQuickReplyButtons] = useState([]);
    const messagesEndRef = useRef(null);

    // Il tuo tag affiliazione Amazon
    const AMAZON_AFFILIATE_TAG = 'tuotagaffiliazione-21'; // <-- INSERISCI QUI IL TUO TAG

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    const addBotMessage = (text, delay = 800, buttons = null) => {
        setTimeout(() => {
            setMessages(prev => [...prev, { from: 'bot', text }]);
            if (buttons) {
                setTimeout(() => {
                    setQuickReplyButtons(buttons);
                    setShowQuickReplies(true);
                }, 300);
            }
        }, delay);
    };

    const handleQuickReply = (buttonText, buttonAction) => {
        // Nasconde i pulsanti
        setShowQuickReplies(false);
        setQuickReplyButtons([]);

        // Aggiunge il messaggio dell'utente
        setMessages(prev => [...prev, { from: 'user', text: buttonText }]);

        // Esegue l'azione del pulsante
        if (buttonAction) {
            buttonAction();
        }
    };

    const generateAmazonLink = (productName) => {
        const searchQuery = encodeURIComponent(productName);
        return `https://www.amazon.it/s?k=${searchQuery}&tag=${AMAZON_AFFILIATE_TAG}`;
    };

    // Funzione per separare prodotti multipli
    const parseMultipleProducts = (text) => {
        // Rimuovi articoli e congiunzioni comuni
        let cleanText = text
            .toLowerCase()
            .replace(/^(una|un|uno|degli|delle|dei|il|lo|la|i|gli|le)\s+/gi, '')
            .trim();

        // Separa per virgole, "e", " ed ", " o "
        const separators = /[,;]|\se\s|\sed\s|\so\s/gi;

        let products = cleanText.split(separators)
            .map(p => p.trim())
            .filter(p => p.length > 0)
            .map(p => {
                // Rimuovi articoli all'inizio di ogni prodotto
                return p.replace(/^(una|un|uno|degli|delle|dei|il|lo|la|i|gli|le)\s+/gi, '').trim();
            });

        // Se non ci sono separatori, ritorna come singolo prodotto
        return products.length > 0 ? products : [cleanText];
    };

    const finishWishlist = (currentWishlist = null) => {
        const listToUse = currentWishlist || wishlist;

        addBotMessage(`OH OH OH! Perfetto ${userName}! La tua letterina è completa!`, 1000);
        addBotMessage(`Ecco la tua Wishlist di Natale Tech:`, 2500);

        setTimeout(() => {
            listToUse.forEach((wish, index) => {
                setTimeout(() => {
                    const amazonLink = generateAmazonLink(wish);
                    setMessages(prev => [...prev, {
                        from: 'bot',
                        text: `${index + 1}. ${wish}`,
                        link: amazonLink,
                        icon: 'fa-gift'
                    }]);
                }, index * 800);
            });
        }, 3000);

        addBotMessage(`Clicca su ogni regalo per cercarlo su Amazon! I miei elfi riceveranno una piccola commissione per aiutarli a costruire più giocattoli! OH OH OH!`, 3000 + listToUse.length * 800 + 500);
        addBotMessage(`Ricorda ${userName}: compila la letterina, condividila con chi ami, e usa il codice per rendere il mondo un posto migliore! Buon Natale! HO HO HO!`, 3000 + listToUse.length * 800 + 3000);
        setConversationStage('farewell');
    };

    const handleUserMessage = (userText) => {
        setMessages(prev => [...prev, { from: 'user', text: userText }]);

        switch (conversationStage) {
            case 'greeting':
                addBotMessage('OH OH OH! Prima di tutto, come ti chiami, giovane elfo del codice?', 1000);
                setConversationStage('asking_name');
                break;

            case 'asking_name':
                setUserName(userText);
                addBotMessage(`Fantastico ${userText}! È un nome meraviglioso! OH OH OH!`, 1000);
                addBotMessage(`Allora ${userText}, sei stato bravo quest'anno? Hai scritto codice pulito?`, 2500);

                // Mostra i pulsanti DOPO il messaggio, con un delay maggiore
                setTimeout(() => {
                    setQuickReplyButtons([
                        {
                            text: 'Sì, sono stato un bravo developer',
                            icon: 'fa-check-circle',
                            action: () => {
                                addBotMessage('OH OH OH! Magnifico! I miei elfi hanno controllato il tuo repository GitHub e confermano!', 1000);
                                addBotMessage(`Allora ${userName}, dimmi... cosa desideri trovare sotto l'albero quest'anno? Puoi dirmi uno o più regali tech!`, 3000);
                                setConversationStage('collecting_wishes');
                            }
                        },
                        {
                            text: 'No, ho usato solo ChatGPT',
                            icon: 'fa-robot',
                            action: () => {
                                addBotMessage('OH OH OH! Non preoccuparti, c\'è sempre tempo per migliorare! Anche i bug hanno diritto a un regalo!', 1000);
                                addBotMessage(`Allora ${userName}, dimmi... cosa desideri trovare sotto l'albero quest'anno? Puoi dirmi uno o più regali tech!`, 3000);
                                setConversationStage('collecting_wishes');
                            }
                        }
                    ]);
                    setShowQuickReplies(true);
                }, 3000); // 2500 (delay messaggio) + 500 extra = 3000

                setConversationStage('asking_behavior');
                break;

            case 'asking_behavior':
                // Nasconde i pulsanti se l'utente scrive manualmente
                setShowQuickReplies(false);
                setQuickReplyButtons([]);

                const isBehaved = userText.toLowerCase().includes('si') ||
                    userText.toLowerCase().includes('sì') ||
                    userText.toLowerCase().includes('bravo') ||
                    userText.toLowerCase().includes('buono');

                if (isBehaved) {
                    addBotMessage('OH OH OH! Magnifico! I miei elfi hanno controllato il tuo repository GitHub e confermano!', 1000);
                } else {
                    addBotMessage('OH OH OH! Non preoccuparti, c\'è sempre tempo per migliorare! Anche i bug hanno diritto a un regalo!', 1000);
                }
                addBotMessage(`Allora ${userName}, dimmi... cosa desideri trovare sotto l'albero quest'anno? Puoi dirmi uno o più regali tech!`, 3000);
                setConversationStage('collecting_wishes');
                break;

            case 'collecting_wishes':
                const products = parseMultipleProducts(userText);

                if (products.length > 1) {
                    // Multipli prodotti rilevati
                    addBotMessage(`OH OH OH! Ho rilevato ${products.length} regali! Li aggiungo tutti alla tua letterina!`, 1000);

                    products.forEach((product, index) => {
                        setTimeout(() => {
                            setMessages(prev => [...prev, {
                                from: 'bot',
                                text: `${index + 1}. ${product}`,
                                icon: 'fa-gift'
                            }]);
                        }, 1500 + (index * 300));
                    });

                    const totalDelay = 1500 + (products.length * 300) + 500;

                    // Aggiorna la wishlist
                    setWishlist(prev => [...prev, ...products]);

                    // Mostra pulsanti DOPO aver aggiornato la wishlist
                    setTimeout(() => {
                        setQuickReplyButtons([
                            {
                                text: 'Ho finito',
                                icon: 'fa-check',
                                action: () => {
                                    setTimeout(() => {
                                        setWishlist(currentList => {
                                            finishWishlist(currentList);
                                            return currentList;
                                        });
                                    }, 100);
                                }
                            },
                            {
                                text: 'Voglio aggiungere altro',
                                icon: 'fa-plus',
                                action: () => {
                                    addBotMessage('Perfetto! Dimmi cosa vuoi aggiungere!', 500);
                                    setConversationStage('collecting_more');
                                }
                            }
                        ]);
                        setShowQuickReplies(true);
                    }, totalDelay);

                    addBotMessage(`Vuoi aggiungere altro alla lista dei desideri?`, totalDelay - 300);
                } else {
                    // Singolo prodotto
                    const newWish = products[0];
                    addBotMessage(`OH OH OH! Ho aggiunto "${newWish}" alla tua letterina!`, 1000);

                    // Aggiorna la wishlist
                    setWishlist(prev => [...prev, newWish]);

                    // Mostra pulsanti
                    setTimeout(() => {
                        setQuickReplyButtons([
                            {
                                text: 'Ho finito',
                                icon: 'fa-check',
                                action: () => {
                                    setTimeout(() => {
                                        setWishlist(currentList => {
                                            finishWishlist(currentList);
                                            return currentList;
                                        });
                                    }, 100);
                                }
                            },
                            {
                                text: 'Voglio aggiungere altro',
                                icon: 'fa-plus',
                                action: () => {
                                    addBotMessage('Perfetto! Dimmi cosa vuoi aggiungere!', 500);
                                    setConversationStage('collecting_more');
                                }
                            }
                        ]);
                        setShowQuickReplies(true);
                    }, 2200);

                    addBotMessage(`Vuoi aggiungere altro alla lista dei desideri?`, 2000);
                }

                setConversationStage('collecting_more');
                break;

            case 'collecting_more':
                // Nasconde i pulsanti se l'utente scrive manualmente
                setShowQuickReplies(false);
                setQuickReplyButtons([]);

                const isDone = userText.toLowerCase().includes('finito') ||
                    userText.toLowerCase().includes('fine') ||
                    userText.toLowerCase().includes('basta') ||
                    userText.toLowerCase().includes('stop');

                if (isDone) {
                    // Usa la wishlist corrente nello state
                    setTimeout(() => {
                        setWishlist(currentList => {
                            finishWishlist(currentList);
                            return currentList;
                        });
                    }, 100);
                } else {
                    const products = parseMultipleProducts(userText);

                    if (products.length > 1) {
                        // Multipli prodotti aggiunti
                        addBotMessage(`OH OH OH! Ho aggiunto altri ${products.length} regali!`, 1000);

                        products.forEach((product, index) => {
                            setTimeout(() => {
                                setMessages(prev => [...prev, {
                                    from: 'bot',
                                    text: `${product}`,
                                    icon: 'fa-gift'
                                }]);
                            }, 1500 + (index * 300));
                        });

                        const totalDelay = 1500 + (products.length * 300) + 500;

                        // Aggiorna wishlist
                        setWishlist(prev => [...prev, ...products]);

                        // Mostra pulsanti
                        setTimeout(() => {
                            setQuickReplyButtons([
                                {
                                    text: 'Ho finito',
                                    icon: 'fa-check',
                                    action: () => {
                                        setTimeout(() => {
                                            setWishlist(currentList => {
                                                finishWishlist(currentList);
                                                return currentList;
                                            });
                                        }, 100);
                                    }
                                },
                                {
                                    text: 'Voglio aggiungere altro',
                                    icon: 'fa-plus',
                                    action: () => {
                                        addBotMessage('Perfetto! Dimmi cosa vuoi aggiungere!', 500);
                                    }
                                }
                            ]);
                            setShowQuickReplies(true);
                        }, totalDelay);

                        addBotMessage(`Vuoi aggiungere altro?`, totalDelay - 300);
                    } else {
                        // Singolo prodotto
                        const newWish = products[0];
                        addBotMessage(`OH OH OH! Ho aggiunto anche "${newWish}"!`, 1000);

                        // Aggiorna wishlist
                        setWishlist(prev => [...prev, newWish]);

                        // Mostra pulsanti
                        setTimeout(() => {
                            setQuickReplyButtons([
                                {
                                    text: 'Ho finito',
                                    icon: 'fa-check',
                                    action: () => {
                                        setTimeout(() => {
                                            setWishlist(currentList => {
                                                finishWishlist(currentList);
                                                return currentList;
                                            });
                                        }, 100);
                                    }
                                },
                                {
                                    text: 'Voglio aggiungere altro',
                                    icon: 'fa-plus',
                                    action: () => {
                                        addBotMessage('Perfetto! Dimmi cosa vuoi aggiungere!', 500);
                                    }
                                }
                            ]);
                            setShowQuickReplies(true);
                        }, 2200);

                        addBotMessage(`Vuoi aggiungere altro?`, 2000);
                    }
                }
                break;

            case 'farewell':
                addBotMessage(`OH OH OH! ${userName}, la tua letterina è già completa! Se vuoi ricominciare, ricarica la pagina! Buon Natale!`, 1000);
                break;

            default:
                addBotMessage('OH OH OH! Qualcosa è andato storto nelle comunicazioni del Polo Nord! Riprova!', 1000);
        }
    };

    const handleSend = (e) => {
        if (e.key === 'Enter' && input.trim()) {
            handleUserMessage(input.trim());
            setInput('');
        }
    };

    return (
        <div
            style={{
                position: 'fixed',
                bottom: '16px',
                right: '25px',
                zIndex: 9999
            }}
        >
            {/* Bottone circolare con animazione */}
            <button
                onClick={() => setIsOpen(!isOpen)}
                style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    background: 'linear-gradient(145deg, rgb(219 70 70), rgb(179 18 18))',
                    boxShadow: '0 4px 15px rgba(220,38,38,0.4), 0 0 20px rgba(220,38,38,0.3)',
                    border: '2px solid rgba(255,255,255,0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    animation: 'pulse 2s infinite'
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.1) rotate(5deg)';
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(220,38,38,0.6)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1) rotate(0deg)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(220,38,38,0.4)';
                }}
            >
                <i className="fas fa-hat-wizard" style={{ color: '#fff', fontSize: '1.6rem' }}></i>
            </button>

            {/* Finestra chat */}
            {isOpen && (
                <div
                    style={{
                        position: 'absolute',
                        bottom: '80px',
                        right: 0,
                        width: '320px',
                        maxHeight: '500px',
                        borderRadius: '1rem',
                        background: 'rgba(17,25,40,0.98)',
                        color: '#e2e8f0',
                        boxShadow: '0 0 30px rgba(0,0,0,0.5), 0 0 15px rgba(220,38,38,0.3)',
                        border: '2px solid rgba(220,38,38,0.3)',
                        backdropFilter: 'blur(10px)',
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    {/* Header */}
                    <div
                        style={{
                            padding: '1rem',
                            background: 'linear-gradient(135deg,#dc2626,#b91c1c)',
                            fontWeight: '700',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            color: '#fff',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <i className="fas fa-sleigh"></i>
                            <span>Babbo Tech</span>
                        </div>
                        <button
                            onClick={() => setIsOpen(false)}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                color: '#fff',
                                cursor: 'pointer',
                                fontSize: '1.2rem',
                                padding: '0',
                                width: '24px',
                                height: '24px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            ×
                        </button>
                    </div>

                    {/* Area messaggi */}
                    <div
                        style={{
                            padding: '1rem',
                            flex: 1,
                            overflowY: 'auto',
                            fontSize: '0.9rem',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.8rem'
                        }}
                    >
                        {messages.map((msg, idx) => (
                            <div
                                key={idx}
                                style={{
                                    display: 'flex',
                                    justifyContent: msg.from === 'bot' ? 'flex-start' : 'flex-end'
                                }}
                            >
                                <div
                                    style={{
                                        maxWidth: '80%',
                                        padding: '0.7rem 1rem',
                                        borderRadius: msg.from === 'bot' ? '0.8rem 0.8rem 0.8rem 0.2rem' : '0.8rem 0.8rem 0.2rem 0.8rem',
                                        background: msg.from === 'bot'
                                            ? 'linear-gradient(135deg, rgba(220,38,38,0.2), rgba(185,28,28,0.2))'
                                            : 'rgba(59,130,246,0.2)',
                                        color: msg.from === 'bot' ? '#fbbf24' : '#e5e7eb',
                                        border: msg.from === 'bot'
                                            ? '1px solid rgba(220,38,38,0.3)'
                                            : '1px solid rgba(59,130,246,0.3)',
                                        wordWrap: 'break-word'
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}>
                                        {msg.from === 'bot' && msg.icon && (
                                            <i className={`fas ${msg.icon}`} style={{
                                                color: '#fbbf24',
                                                fontSize: '0.9rem',
                                                marginTop: '0.15rem',
                                                flexShrink: 0
                                            }}></i>
                                        )}
                                        <span style={{ flex: 1 }}>{msg.text}</span>
                                    </div>
                                    {msg.link && (
                                        <div style={{ marginTop: '0.5rem' }}>
                                            <a
                                                href={msg.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    color: '#60a5fa',
                                                    textDecoration: 'none',
                                                    fontSize: '0.85rem',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: '0.3rem',
                                                    padding: '0.3rem 0.6rem',
                                                    background: 'rgba(59,130,246,0.2)',
                                                    borderRadius: '0.4rem',
                                                    border: '1px solid rgba(59,130,246,0.3)',
                                                    transition: 'all 0.2s'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.background = 'rgba(59,130,246,0.3)';
                                                    e.currentTarget.style.transform = 'scale(1.05)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.background = 'rgba(59,130,246,0.2)';
                                                    e.currentTarget.style.transform = 'scale(1)';
                                                }}
                                            >
                                                <i className="fas fa-search"></i>
                                                Guarda il tuo regalo
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                        <div ref={messagesEndRef} />
                    </div>

                    {/* Quick Reply Buttons */}
                    {showQuickReplies && quickReplyButtons.length > 0 && (
                        <div style={{
                            padding: '0.8rem 1rem',
                            borderTop: '1px solid rgba(255,255,255,0.05)',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.5rem',
                            background: 'rgba(0,0,0,0.1)'
                        }}>
                            {quickReplyButtons.map((button, index) => (
                                <button
                                    key={index}
                                    onClick={() => handleQuickReply(button.text, button.action)}
                                    style={{
                                        padding: '0.7rem 1rem',
                                        borderRadius: '0.6rem',
                                        border: '1px solid rgba(220,38,38,0.3)',
                                        background: 'linear-gradient(135deg, rgba(220,38,38,0.15), rgba(185,28,28,0.15))',
                                        color: '#fbbf24',
                                        cursor: 'pointer',
                                        fontWeight: '600',
                                        fontSize: '0.85rem',
                                        transition: 'all 0.2s',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '0.5rem'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = 'linear-gradient(135deg, rgba(220,38,38,0.25), rgba(185,28,28,0.25))';
                                        e.currentTarget.style.transform = 'scale(1.02)';
                                        e.currentTarget.style.borderColor = 'rgba(220,38,38,0.5)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background = 'linear-gradient(135deg, rgba(220,38,38,0.15), rgba(185,28,28,0.15))';
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.borderColor = 'rgba(220,38,38,0.3)';
                                    }}
                                >
                                    <i className={`fas ${button.icon}`}></i>
                                    {button.text}
                                </button>
                            ))}
                        </div>
                    )}

                    {/* Input area */}
                    <div
                        style={{
                            padding: '1rem',
                            borderTop: '1px solid rgba(255,255,255,0.1)',
                            background: 'rgba(0,0,0,0.2)'
                        }}
                    >
                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                            <input
                                type="text"
                                placeholder="Scrivi la tua letterina..."
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                onKeyDown={handleSend}
                                style={{
                                    flex: 1,
                                    padding: '0.6rem 0.8rem',
                                    borderRadius: '0.5rem',
                                    border: '1px solid rgba(255,255,255,0.2)',
                                    outline: 'none',
                                    background: 'rgba(255,255,255,0.1)',
                                    color: '#fff',
                                    fontSize: '0.9rem'
                                }}
                            />
                            <button
                                onClick={() => {
                                    if (input.trim()) {
                                        handleUserMessage(input.trim());
                                        setInput('');
                                    }
                                }}
                                style={{
                                    padding: '0.6rem 1rem',
                                    borderRadius: '0.5rem',
                                    border: 'none',
                                    background: 'linear-gradient(135deg, #dc2626, #b91c1c)',
                                    color: '#fff',
                                    cursor: 'pointer',
                                    fontWeight: '600',
                                    transition: 'all 0.2s'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            >
                                Invia
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                @keyframes pulse {
                    0%, 100% {
                        box-shadow: 0 4px 15px rgba(220,38,38,0.4), 0 0 20px rgba(220,38,38,0.3);
                    }
                    50% {
                        box-shadow: 0 4px 25px rgba(220,38,38,0.6), 0 0 30px rgba(220,38,38,0.5);
                    }
                }
            `}</style>
        </div>
    );
};

export default SantaChatbot;